import { render, staticRenderFns } from "./EditorDoc.vue?vue&type=template&id=dcee5bce&scoped=true"
import script from "./EditorDoc.vue?vue&type=script&lang=js"
export * from "./EditorDoc.vue?vue&type=script&lang=js"
import style0 from "./EditorDoc.vue?vue&type=style&index=0&id=dcee5bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcee5bce",
  null
  
)

export default component.exports